
import React from 'react';
import '../../components/Filters/CertificatesFilter.css';
import { LettersFilterProps } from '../../types/letterGraph';

const LettersFilter: React.FC<LettersFilterProps> = ({
    dateFrom,
    dateTo,
    numberQuery,
    createdBy,
    responsible,
    subject,
    toPerson,
    fromPerson,
    emailSender,
    emailReceiver,
    onChange,
    onReset,
    onClose,
    createdByOptions,
    responsibleOptions,
    toPersonOptions,
    subjectOptions,
    fromPersonOptions,
    emailSenderOptions,
    emailReceiverOptions,
    activeCount,
    activeEntries,
    onRemoveActive,
    onApply,
}) => {
    return (
        <div className="certificates-filter-modal" onClick={(e) => e.stopPropagation()}>
            <button className="certificates-filter-modal__close" onClick={onClose}>×</button>
            <div className="filter-header" style={{ alignItems: 'center' }}>
                <h3 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    Фильтры <span className="filter-count">{activeCount}</span>
                </h3>
            </div>
            <div className="filter-actions" style={{ gap: 55, flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
                <button className="reset-button" onClick={onReset}>Сбросить</button>
               {/* Кнопка применить */}
                <button
                    onClick={onApply}
                    style={{
                        padding: '8px 16px',
                        border: 'none',
                        background: '#0074b7',
                        color: '#fff',
                        borderRadius: 6,
                        cursor: 'pointer',
                        fontSize: 14,
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        outline: 'none',
                        boxShadow: 'none'
                    }}
                >
                    Применить
                </button>
            </div>

            {/* Секция активных фильтров */}
            <div className="filter-group2" style={{ marginBottom: 16 }}>
                <h4>Активные фильтры:</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {activeEntries.length === 0 ? (
                        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 10, background: '#fff', color: '#6b7280', fontSize: 13 }}>
                            Нет активных фильтров
                        </div>
                    ) : (
                        activeEntries.map((it) => (
                            <div key={it.key} style={{ position: 'relative', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, background: '#fff' }}>
                                <div style={{ fontWeight: 600, fontSize: 13, color: '#111827', marginBottom: 6 }}>{it.title}</div>
                                <button
                                    aria-label="Удалить фильтр"
                                    onClick={() => onRemoveActive(it.key)}
                                    style={{ position: 'absolute', right: 10, top: 8, border: 'none', background: 'transparent', color: '#ef4444', cursor: 'pointer', fontSize: 16 }}
                                >
                                    ×
                                </button>
                                <div style={{ whiteSpace: 'pre-wrap', color: '#111827', fontSize: 13 }}>{it.value}</div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {/* Поля фильтрации */}
            <div className="filter-fields">
                {/* Фильтр по дате */}
                <div className="filter-group2" style={{ gridColumn: '1 / -1' }}>
                    <h4>Дата</h4>
                    <div className="filter-field">
                        <label>Дата с</label>
                        <input
                            className="date-input"
                            type="date"
                            value={dateFrom}
                            onChange={(e) => onChange({ dateFrom: e.target.value })}
                        />
                    </div>
                    <div className="filter-field">
                        <label>Дата по</label>
                        <input
                            className="date-input"
                            type="date"
                            value={dateTo}
                            onChange={(e) => onChange({ dateTo: e.target.value })}
                        />
                    </div>
                </div>

                {/* Фильтр по полям письма */}
                <div className="filter-group2" style={{ gridColumn: '1 / -1' }}>
                    <h4>Письмо</h4>
                    <div className="filter-field">
                        <label>Номер письма</label>
                        <input
                            className="date-input"
                            value={numberQuery}
                            onChange={(e) => onChange({ numberQuery: e.target.value })}
                            placeholder="Например: 520/25-АПТС"
                        />
                    </div>
                    <div className="filter-field">
                        <label>Тема</label>
                        <input
                            className="date-input"
                            list="lettersSubjList"
                            value={subject}
                            onChange={(e) => onChange({ subject: e.target.value })}
                            placeholder="Введите тему"
                        />
                        <datalist id="lettersSubjList">
                            {subjectOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                    <div className="filter-field">
                        <label>От кого</label>
                        <input
                            className="date-input"
                            list="lettersFromList"
                            value={fromPerson}
                            onChange={(e) => onChange({ fromPerson: e.target.value })}
                            placeholder="Введите отправителя"
                        />
                        <datalist id="lettersFromList">
                            {fromPersonOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                    <div className="filter-field">
                        <label>Кому</label>
                        <input
                            className="date-input"
                            list="lettersToList"
                            value={toPerson}
                            onChange={(e) => onChange({ toPerson: e.target.value })}
                            placeholder="Введите адресата"
                        />
                        <datalist id="lettersToList">
                            {toPersonOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                    <div className="filter-field">
                        <label>Email отправителя</label>
                        <input
                            className="date-input"
                            list="lettersEmailSenderList"
                            value={emailSender}
                            onChange={(e) => onChange({ emailSender: e.target.value })}
                            placeholder="Введите email отправителя"
                        />
                        <datalist id="lettersEmailSenderList">
                            {emailSenderOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                    <div className="filter-field">
                        <label>Email получателя</label>
                        <input
                            className="date-input"
                            list="lettersEmailReceiverList"
                            value={emailReceiver}
                            onChange={(e) => onChange({ emailReceiver: e.target.value })}
                            placeholder="Введите email получателя"
                        />
                        <datalist id="lettersEmailReceiverList">
                            {emailReceiverOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                    <div className="filter-field">
                        <label>Ответственный</label>
                        <input
                            className="date-input"
                            list="lettersRespList"
                            value={responsible}
                            onChange={(e) => onChange({ responsible: e.target.value })}
                            placeholder="Введите ответственного"
                        />
                        <datalist id="lettersRespList">
                            {responsibleOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                    <div className="filter-field">
                        <label>Автор записи</label>
                        <input
                            className="date-input"
                            list="lettersCreatedByList"
                            value={createdBy}
                            onChange={(e) => onChange({ createdBy: e.target.value })}
                            placeholder="Введите автора"
                        />
                        <datalist id="lettersCreatedByList">
                            {createdByOptions.map(v => (<option key={v} value={v} />))}
                        </datalist>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default LettersFilter;

